import { FORMATDATEMMDD } from "src/utils";
import { BASE_URL, EMP_BASE_URL, PRODUCT_BASE_URL } from "./appConst";
import { axiosAuth } from "./common";
import { EditCustomerFormValues } from "src/screens/Dashboard/ManageCustomers/schema/edit-customer.schema";
import { EditMemberFormValues } from "src/screens/Dashboard/ManageCustomers/schema/edit-member.schema";
import { BasicInfoValues } from "src/screens/Dashboard/ManageCustomers/schema/basic-info.schema";
import { CustomerFilters } from "src/screens/Dashboard/ManageCustomers/hooks/useFetchCustomers";

// get the list of registered customer

export const fetchCustomersapi = async (
  filters: CustomerFilters,
) => {
  const params = new URLSearchParams();

  params.set("page", filters.page.toString());
  params.set("pagesize", filters.pagesize.toString());

  if (filters.state) params.set("state", filters.state);
  if (filters.district) params.set("district", filters.district);
  if (filters.name.trim()) params.set("name", filters.name.trim());
  if (filters.email.trim()) params.set("email", filters.email.trim());
  if (filters.employee_name.trim()) params.set("employee_name", filters.employee_name.trim());
  if (filters.employee_code.trim()) params.set("employee_code", filters.employee_code.trim());
  if (filters.health_seeker) params.set("health_seeker", filters.health_seeker);
  if (filters.fromDate && filters.toDate) {
    params.set("startdate", filters.fromDate);
    params.set("enddate", filters.toDate);
  }

  const api = axiosAuth();

  const { data } = await api.get(`${PRODUCT_BASE_URL}/get-customer?${params.toString()}`,);

  return data.data.customers;
};

export const getCustomers = async (
  pageNumber: number,
  pagesize: number,
  query: string,
) => {
  const api = axiosAuth();

  const response = await api.get(
    `${PRODUCT_BASE_URL}/get-customer?page=${pageNumber}&pagesize=${pagesize}&${query}`,
  );

  return response.data;
};

// book customer for free session
export const bookCustomers = async (ids: number[]) => {
  const api = axiosAuth();

  const response = await api.patch(`${EMP_BASE_URL}/customer/booked`, {
    id: ids,
  });

  return response.data;
};

// delete selected customers
export const deleteCustomers = async ({ids, emails}: {ids: number[], emails: string[]}) => {
  const api = axiosAuth();

  const response = await api.delete(`${BASE_URL}/customer/delete`, {
    data: {
      ids: ids,
      email: emails,
    },
  });

  return response.data;
};

// add free session slot for customers
export const addFreeSlots = async (values) => {
  const api = axiosAuth();

  const response = await api.post(`${PRODUCT_BASE_URL}/add-session-slot`, {
    state: values.state,
    district: values.district,
    date: FORMATDATEMMDD(values.date), // mm-dd-yyyy format
    start_time: values.start_time,
    end_time: values.end_time,
    pin_code: values.pin_code,
  });

  return response.data;
};

// get free session slots list
export const getFreeSlots = async (pageNumber, pageSize, queryStirng) => {
  const api = axiosAuth();

  const response = await api.get(
    `${PRODUCT_BASE_URL}/session-slot?page=${pageNumber}&pagesize=${pageSize}&${queryStirng}`,
  );

  return response.data;
};

export const getAddedMembers = async (subscriptionId: number) => {
  const api = axiosAuth();

  const res = await api.get(
    `${PRODUCT_BASE_URL}/admin/members?subscription_id=${subscriptionId}`,
  );

  return res.data.data.members;
};

export const getAssignedEmployee = async (id: number) => {
  const api = axiosAuth();

  const { data } = await api.get(`${PRODUCT_BASE_URL}/customer/${id}/employee`);

  return data.data.employee;
};

export const editCustomer = async (
  customerId: number,
  values: Partial<EditCustomerFormValues>,
) => {
  const api = axiosAuth();

  const payload = {
    id: customerId,
    ...values,
  };

  const { data } = await api.patch(
    `${PRODUCT_BASE_URL}/admin/customer/${customerId}`,
    payload,
  );

  return data.data.customer.id;
};

export const editMember = async (
  values: Partial<EditMemberFormValues>,
  memberId: number,
) => {
  const api = axiosAuth();

  const { data } = await api.patch(`${PRODUCT_BASE_URL}/admin/members/${memberId}`, {
    id: memberId,
    ...values,
  });

  return data.data.member.id;
};

export const addBasicInfo = async (
  memberId: number,
  values: BasicInfoValues,
) => {
  const api = axiosAuth();

  const { data } = await api.patch(
    `${PRODUCT_BASE_URL}/admin/members/${memberId}`,
    {
      id: memberId,
      ...values,
    },
  );

  return data.data.member.id;
};

export const editBloodGroup = async (
  memberId: number,
  values: {
    blood_group: string;
  },
) => {
  const api = axiosAuth();

  const { data } = await api.patch(
    `${PRODUCT_BASE_URL}/admin/members/${memberId}`,
    {
      id: memberId,
      ...values,
    },
  );

  return data.data.member.id;
};

